import React from "react";
import { Avatar, FontIcon } from "react-md";

const NavigatorListIemAvatar = ({ status }) => {
  switch (status) {
    case "complete":
      return <Avatar suffix="green" icon={<FontIcon>done</FontIcon>} />;
    case "active":
      return (
        <Avatar suffix="red" icon={<FontIcon>keyboard_arrow_right</FontIcon>} />
      );
    default:
      return (
        <Avatar suffix="gray" icon={<FontIcon>keyboard_arrow_down</FontIcon>} />
      );
  }
};

NavigatorListIemAvatar.propTypes = {};
NavigatorListIemAvatar.defaultProps = {};

export default NavigatorListIemAvatar;



// WEBPACK FOOTER //
// ./src/registration/components/RegistrationNavigator/NavigatorListItemAvatar.jsx